import type { CartReminderBasket, CartReminderDecisionInput } from "./types";

/** SFCC-12333: auto-dismiss "after about 6 to 8 seconds" — the midpoint. */
export const CART_REMINDER_AUTO_DISMISS_MS = 7000;

/**
 * `undefined` while the first basket load is still in flight, so the caller
 * can wait for it. A load that settled without a basket (SLAS throttle, failed
 * hydrate) counts as empty — waiting there would defer the decision to the
 * next good payload, typically a mid-session add-to-cart.
 */
export const basketHasItems = (
  basket: CartReminderBasket | undefined,
  settled: boolean,
): boolean | undefined => {
  if (basket) return (basket.productItems?.length ?? 0) > 0;
  return settled ? false : undefined;
};

/**
 * Show once per session, only when the cart already has items at the moment
 * the session's first page decides, and never on an excluded route.
 */
export const shouldShowCartReminder = ({
  seenThisSession,
  hasItems,
  excluded,
}: CartReminderDecisionInput): boolean =>
  !seenThisSession && hasItems && !excluded;
